import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux';
import { Modal } from 'vqp-common';
import { Button, Icon, Loading } from '../../../../components/common'
import { fetchCupomDataUse } from '../../../../redux/actions/coupon';

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`
const Wrapper = styled.div`
  margin: 20px;
  min-height: 100px;
`
const Title = styled.h1`
  font-size: 24px;
  border-bottom: 1px solid ${props => props.theme.colors.lineGrey};
  padding: 2px 0 0 0;
  margin-bottom: 1.25rem;

  >div{
    margin: 0 4px;
  }
`
const Label = styled.h4`
  font-size: 14px;
`
const Number = styled.h2`
  font-size: 32px;
  color: ${props => props.theme.colors.primary};
`
const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
export const DivButtonSave = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0 10px 8px;
    padding: 8px;
    border-radius: 10px;
    align-items: center;
`
export const SaveButton = styled(Button)`
`
export const InfoCupomModal = ({ isOpen, cupomId, onClose }) => {
  const [info, setInfo] = useState()
  const [loading, setLoading] = useState()
  const dispatch = useDispatch()

  useEffect(() => {
    const getInfoCupom = async () => {
      setLoading(true)
      const result = await dispatch(fetchCupomDataUse(cupomId))
      if (result.success) {
        setInfo(result.data)
      }
      setLoading(false)
    }
    if (cupomId) {
      setLoading(true)
      getInfoCupom()
    } else {
      setInfo(undefined)
    }
  }, [dispatch, cupomId])

  return (
    <Modal isOpen={isOpen} onClose={onClose} boxWidth={"400px"}>
      {loading && (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      )}
      <Wrapper>
        {!loading ? <>
          <Title>Dados de Uso</Title>
          <Section>
            <Label>Pedidos concluidos com esse cupom:</Label>
            <Number>{info?.quantitiesRequests}</Number>
            <Label>Usuários que usaram este cupom:</Label>
            <Number>{info?.quantitiesUsers}</Number>
          </Section>
          <DivButtonSave>
            <SaveButton className="primary" onClick={onClose}>
              Ok
            </SaveButton>
          </DivButtonSave>
        </> : <></>}
      </Wrapper>
    </Modal>
  )
}
